<template>
    <div class="order-order order-step">
        <div class="order-step__title order-order__title">Оформление заказа</div>
        <form @submit.prevent="nextStep" class="form order-order__form">
            <div class="order-order__ordering" :class="{addPadding : orderListWarning || showDisclaimerWeekend}">
                <div class="order-order__ordering-payment">
                    <div class="form__label form__label_payment">Способ оплаты</div>
                    <div class="form__row">
                        <div class="checkbox" v-if="enableHomeCardPayment">
                            <input id="homecard" name="payment" type="radio" v-model="orderInfo.payment" value="homecard" />
                            <label for="homecard"><span class="checkbox-icon"></span>Олата на месте по карте</label>
                        </div>
                        <div
							:class="['checkbox',
								{'__disabled': isBlockedOnlinePayment}
							]"
							v-if="enableCardPayment && !acitonsArr.length">
                            <input id="card" name="payment" type="radio" v-model="orderInfo.payment" value="card" />
                            <label for="card"><span class="checkbox-icon"></span>Картой онлайн</label>
                        </div>
                        <div class="checkbox">
                            <input id="other" name="payment" type="radio" v-model="orderInfo.payment" value="other" />
                            <label for="other"><span class="checkbox-icon"></span>Другое (по страховке ДМС)</label>
                        </div>
                        <div class="checkbox">
                            <input id="cash" name="payment" type="radio" v-model="orderInfo.payment" value="cash" />
                            <label for="cash"><span class="checkbox-icon"></span>Оплата на месте наличными</label>
                        </div>
                         <!-- для депозита -->
                        <!-- <div class="checkbox">
                            <input id="deposit" name="payment" type="radio" v-model="orderInfo.payment" value="deposit" />
                            <label for="deposit"><span class="checkbox-icon"></span>Оплата с депозита</label>
                        </div> -->
                    </div>
                     <!-- для депозита -->
                    <!-- <div class="form__row _selector-contracts">
                        <div class="form__field _selector-contracts">
                                <FormSelect
                                    :data-array="orderInfo.orderDepositСontracts"
                                    placeholder="Выбор договора"
                                    v-model="orderInfo.orderDepositSelected"
                                    :value="orderInfo.orderDepositSelected"
                                    
                                />
                        </div>
                        <div class="form__field">
                            <div :class="['form__field-wrapper order-sum_avalible', {focused: orderInfo.sumAvalible}]">
                                <div class="form__field-label">Доступный остаток средств</div>
                                <input type="text" readonly v-focus v-model="orderInfo.sumAvalible" />
                            </div>
                        </div>
                        <div class="form__field">
                            <div :class="['form__field-wrapper order-sum_write-off', {focused: orderInfo.sumWriteOff}]">
                                <div class="form__field-label">Сумма списания</div>
                                <input type="text" v-focus v-model="orderInfo.sumWriteOff" />
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="order-services__buttons-disclaimer order-order__order-list-warning" v-if="!!errorSubmit" v-html="errorSubmit" />
                <div class="order-services__buttons">
                    <button type="button" class="button button_light" @click.prevent="prevStep">Назад</button>
                    <button
                        :disabled="!total || !orderInfo.conditions || !!errorSubmit"
                        class="button button_dark"
                        type="submit"
                    >{{ btnText }}</button>
                </div>
            </div>
            <div class="order-services__order-shadow" v-if="orderOpened" />
            <div class="order-services__order-wrapper" sticky-container>
            <Preloader
                :show="preloader"
            />
                <div
                    :class="['order-order__order', { opened: orderOpened }]"
                    sticky-offset="{top: 70}"
                    v-sticky="isDesktop"
                    v-sticky-order
                >
                    <div class="order-services__order-border">
                        <div @click="viewOrder" class="_g-visible-tablet order-services__order-open" v-if="order.length || orderOpened" />
                        <div class="order-services__order-top">
                            <div class="order-order__order-title">Ваш заказ</div>
                            <vue-custom-scrollbar class="order-order__order-list-scroll" :class="{_isOdd : isOdd}" :settings="scrollBarSettings">
                                <div class="order-order__order-list" data-scroll-lock-scrollable>
                                    <div :key="index" class="order-order__order-item" v-for="(item, index) in order">
                                        <div class="order-order__order-item-top">
                                            <div class="order-order__order-item-name">
                                                {{ item.title }}
<!--                                                <span class="order-order__order-item-desc" v-if="item.descPrice && !item.hasPriceWeekend"><br>{{ item.descPrice }}</span>-->
                                            </div>
                                            <div class="order-order__order-item-price">
                                                {{ (item.id == 'fake_nurse' || item.id == 'fake_nurse_uzi') ? 'от' : '' }} {{ item.price | formatNumber }}&nbsp;&#8381;
                                                <div @click="removeService(item)" class="order-order__order-item-close" />
                                            </div>
                                        </div>
                                        <count
                                            :key="`${item.id}-${item.num}`"
                                            :num.sync="item.num"
                                            @update="checkZero(item.id, item.num)"
                                            v-if="item.enum"
                                        />
                                    </div>
                                    <div v-if="acitonsArr.length && !isDesktop" class="order-order__order-action">
                                        {{ acitonsArr.length > 1 ? 'Выбранные' : 'Выбранная' }} Вами {{ acitonsArr.length > 1 ? 'услуги:' : 'услуга:' }} <br> <span class="order-order__order-action__list" v-for="(i, key) of acitonsArr" :key="key">{{i + ', '}}<br></span> {{ acitonsArr.length > 1 ? 'участвуют' : 'участвует' }}  в акции «Золотая пора скидок». Оплата возможна только при визите медицинского сотрудника наличными или банковской картой.
                                    </div>
                                </div>
                            </vue-custom-scrollbar>
                        </div>
                        <div class="order-services__order-bottom" :class="{column : orderListWarning || showDisclaimerWeekend}">
                            <div class="order-order__order-list-disclaimers">
                                <div
                                    class="order-order__order-list-warning"
                                    v-html="orderListWarning || disclaimerWeekend"
                                    v-if="orderListWarning || showDisclaimerWeekend"
                                />
                                <div class="order-order__order-list-warning" v-if="!!errorSubmit" v-html="errorSubmit" />
                            </div>
                            <div v-if="acitonsArr.length && isDesktop" class="order-order__order-action">
                                {{ acitonsArr.length > 1 ? 'Выбранные' : 'Выбранная' }} Вами {{ acitonsArr.length > 1 ? 'услуги:' : 'услуга:' }} <br> <span class="order-order__order-action__list" v-for="(i, key) of acitonsArr" :key="key">{{i + ', '}}<br></span> {{ acitonsArr.length > 1 ? 'участвуют' : 'участвует' }}  в акции «Золотая пора скидок». Оплата возможна только при визите медицинского сотрудника наличными или банковской картой.
                            </div>
                            <!-- для депозита -->
                            <!-- <div class="order-order__order-sum">
                                <div class="order-order__order-sum-label">Общая сумма</div>
                                <div class="order-order__order-sum-value">
                                    {{ total | formatNumber }}&nbsp;&#8381;
                                </div>
                            </div>
                            <div class="order-order__order-sum">
                                <div class="order-order__order-sum-label">Оплата с депозита</div>
                                <div class="order-order__order-sum-value">
                                    {{ orderInfo.sumWriteOff | formatNumber }}&nbsp;&#8381;
                                </div>
                            </div>
                            <div class="order-order__order-total">
                                <div class="order-order__order-total-label">Итого</div>
                                <div class="order-order__order-total-value">
                                    {{ (total - orderInfo.sumWriteOff) | formatNumber }}&nbsp;&#8381;
                                </div>
                            </div> -->
                            <div class="order-order__order-total">
                                <div class="order-order__order-total-label">Итого</div>
                                <div class="order-order__order-total-value">
                                    {{ total | formatNumber }}&nbsp;&#8381;
                                </div>
                            </div>
                            <button
                                :disabled="!total || !orderInfo.conditions || !!errorSubmit"
                                class="order-order__order-btn button button_dark"
                                :class="{column : orderListWarning || showDisclaimerWeekend}"
                                type="submit"
                            >
                                <span class="_g-hidden-tablet">{{ btnText }}</span>
                                <span class="_g-visible-tablet-only">{{ btnTextShort }}</span>
                                <span class="_g-visible-mobile">{{ btnText }}</span>
                            </button>
                        </div>
                        <div class="agreement_and_docs">
                            <div class="agreement_and_docs_text">
                                * Нажимая кнопку «{{ btnText }}», вы соглашаетесь с обработкой своих персональных данных АО «Группа компаний «МЕДСИ»
                            </div>
                            <div class="agreement_and_docs_docs">
                                <div>
                                    <a class="agreement_and_docs_links" href="https://medsi.ru/document_politics.php" target="_blank">Политика в отношении обработки персональных данных</a>
                                </div>
                                <div>
                                    <a class="agreement_and_docs_links" href="https://medsi.ru/document_agreement.php" target="_blank">Согласие на обработку персональных данных</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import Count from './Count';
    import {ru} from 'vuejs-datepicker/dist/locale'
    import Sticky from 'vue-sticky-directive';
    import {disablePageScroll, enablePageScroll} from 'scroll-lock';
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import Preloader from "@/components/Preloader";
    // import FormSelect from "./FormSelect.vue";

    export default {
        name: 'OrderPayment',
        props: {
            order: {
                type: Array,
                default: () => [],
            },
            orderTemp: {
                type: Array,
                default: () => [],
            },
            mode: {
                type: String,
                default: 'pnd',
            },
            orderInfo: {
                payment: 'cash',
                conditions: true,
                orderDepositСontracts: [],
                orderDepositSelected: '',
                // sumAvalible: '',
                // sumWriteOff: ''
            },
            enableCardPayment: {
                type: Boolean,
                default: false,
            },
            enableHomeCardPayment: {
                type: Boolean,
                default: false,
            },
            showDisclaimerWeekend: {
                type: Boolean,
                default: false
            },
            errorSubmit: {
                type: String,
                default: ''
            },
            preloader: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                orderServices: [],
                ru: ru,
                isDesktop: window.matchMedia('(min-width: 1025px)').matches,
                orderOpened: false,
                scrollBarSettings: {
                    suppressScrollY: false,
                    suppressScrollX: false,
                    wheelPropagation: false,
                    wheelSpeed: 0.3,
            },
            orderListWarning: null,
            orderListWarningTimeout: null,
            acitonsArr: [],
            isOdd: window.innerHeight %2,
          }
        },
        methods: {
            nextStep() {
                this.$emit('next');
                window.scrollTo(0, 0);
            },
            prevStep() {
                this.$emit('prev');
            },
            removeService(item) {
                let list = this.orderServices;
                const isAutoNurse = item.auto;

                if (item.servicesWeekIds && item.servicesWeekIds.length) {
                    item.servicesWeekIds.forEach(id => {
                        list = this._remove(list, id, isAutoNurse);
                    });
                } else {
                    list = this._remove(list, item.id, isAutoNurse);
                }
                this.orderServices = list;

                setTimeout(()=>{
                    this.checkActions();
                },500)
            },
            _remove(list, id, isAutoNurse) {
                if (!isAutoNurse) {
                    list = list.filter(x => x.id !== id);
                } else {
                    if (list.length === 1) {
                        list = list.filter(x => x.id !== id);
                    } else {
                        this.orderListWarning = 'В корзине присутствуют медицинские манипуляции, которые должна выполнять медсестра или врач.';

                        if (this.orderListWarningTimeout) {
                            clearTimeout(this.orderListWarningTimeout);
                        }

                        this.orderListWarningTimeout = setTimeout(() => {
                            clearTimeout(this.orderListWarningTimeout);
                            this.orderListWarningTimeout = null;
                            this.orderListWarning = null;
                        }, 5000);
                    }
                }
                return list;
            },
            checkZero(id, num) {
                if (!num) {
                    this.orderServices = this.orderServices.filter(x => x.id !== id);
                }
            },
            viewOrder() {
                this.orderOpened = !this.orderOpened;

                const siteScrollTop = document.documentElement.scrollTop;
                const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                const footerEl = document.getElementById('footer');
                const {top} = footerEl.getBoundingClientRect();
                const footerTop = top + siteScrollTop - screenHeight;

                if (this.orderOpened && (siteScrollTop > footerTop)) {
                    this.$scrollTo(document.documentElement, 300, {
                        offset: footerTop,
                        force: true,
                        cancelable: false,
                        onDone: disablePageScroll,
                    });
                } else {
                    this.orderOpened ? disablePageScroll() : enablePageScroll();
                }
            },
            checkActions() {
                this.acitonsArr = [];

                for(let item of this.order) {
                    if(item.is_price_action) {
                        this.acitonsArr.push(item.title)
                    }
                }
            },
        },
        components: {
            Preloader,
            Count,
            vueCustomScrollbar,
            // FormSelect
        },
        directives: { Sticky },
        watch: {
            orderServices() {
                this.$emit('update:order-temp', this.orderServices);
            }
        },
        computed: {
            total() {
                return this.order.length ? this.order.reduce((acc, obj) => {
                    return acc + Number(obj.price) * obj.num
                }, 0) : 0;
            },
            btnText() {
                if(this.orderInfo.payment === 'card') {
                    return 'Перейти к оплате'
                } else {
                    return 'Завершить оформление'
                }
            },
            btnTextShort() {
                if(this.orderInfo.payment === 'card') {
                    return 'К оплате'
                } else {
                    return 'Оформить'
                }
            },
			isBlockedOnlinePayment() {
				let result = false;
				this.orderTemp.forEach(s => {
					s.onlinePayment === false ? result = true : ''
				})

				return result;
			}
        },
        created() {
            this.checkActions();
        },
        mounted() {
            this.orderServices = [...this.orderTemp];
			this.orderInfo.payment = "cash"
        },
    }
</script>
<style lang="scss">
    @import "../../scss/base/include";

    .order-order {
        position: relative;
        margin-bottom: 101px !important;
        @include tablet {
            position: static !important;
        }
        @include mobile {
            margin-bottom: 0 !important;
            padding-bottom: 48px !important;
        }

        &::after {
            content: '';
            position: absolute;
            width: 132px;
            height: 115px;
            background: center url(/local/templates/pnd/src/assets/i2/decor.png) no-repeat;
            z-index: -1;
            right: -55px;
            bottom: -50px;
            @include tablet {
                display: none;
            }
        }

        @include mobile {
            .form__row,
            .form__row-col {
                display: block;
                margin-bottom: 10px;
            }
        }

        &__checkbox-wrapper {
            flex-direction: row;
            justify-content: flex-start;
        }

        &__ispatient {
            flex-grow: 1;
            margin-bottom: 20px;
            margin-left: -10px;
        }

        &__ispatronymic {
            width: calc(50% + 25px);
            margin-bottom: 20px;
            margin-left: -10px;
        }

        &__gender-wrapper {
            margin-bottom: 20px;
            @include mobile {
                margin-bottom: 15px;
                margin-top: 15px;
            }
        }

        &__gender {
            align-items: center;

            &-title {
                margin-right: 10px;
            }

            .form__field-checkbox {
                flex: 1 1 auto;
                @include mobile {
                    margin: 10px 0;
                }
            }
        }

        &__form {
            display: flex;
            justify-content: space-between;

            .vue-sticky-placeholder {
                width: 320px;
                float: right;
            }
        }

        &__ordering {
          width: calc(100% - 380px);
          float: left;

          &-data {
            margin: 0 10px 20px;
            width: calc(50% - 20px);
            max-width: calc(50% - 20px);
            flex: 1 1 auto;
          }

          &-data.disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          &-data.disabled input {
            pointer-events: none;
          }

          @include tablet {
            padding-bottom: 100px;
            width: 100%;
          }
          @include mobile {
            padding-bottom: 0px;
            &-data {
                width: auto;
                max-width: 100%;
                margin-bottom: 10px;
                }
            }

            &-patient {
                margin-bottom: 55px;

                .checkbox {
                    &-text {
                        display: inline-block;
                    }
                }

                @include tablet {
                    .checkbox {
                        label {
                            font-size: 14px;
                        }

                        &-icon {
                            top: 2px;
                        }

                        &-text {
                            line-height: 17px;
                        }
                    }
                }
                @include mobile {
                    margin-bottom: 35px;

                    .checkbox {
                        label {
                            font-size: 15px;
                        }

                        &-text {
                            line-height: 18px;
                        }
                    }
                }
            }

            &-info {
                margin-bottom: 80px;
                @include mobile {
                    margin-bottom: 33px;
                }

                .form__row-col {
                    @include mobile {
                        width: auto;
                        min-width: 0;
                        max-width: none;
                    }
                }
            }

            &-payment {
                .checkbox {
                    margin: 15px 30px 0 10px;
                    width: calc(50% - 40px);
                    white-space: nowrap;

					&.__disabled {
						pointer-events: none;
						opacity: .5;
					}
                    @include mobile {
                        &:not(:last-child) {
                            margin-top: 0px;
                            margin-bottom: 20px;
                            width: 100%;
                        }
                        label {
                            line-height: 24px;
                            font-size: 15px;
                        }
                    }
                }
                .form__row {
                    flex-wrap: wrap;
                }
                .order-sum_avalible {
                    border: none;
                    padding: 16px 0px 0;

                    input {
                        cursor: default;
                    }
                }
            }
            &-appointment {
                flex: 1 1 auto;
                width: 1px;
            }
        }

        &__ordering.addPadding {

            @include tablet {
                padding-bottom: 190px;
            }

            @include mobile {
                padding-bottom: 290px;
            }

        }

        &__title {
            margin-bottom: 47px;
            display: flex;
            align-items: baseline;
            @include tablet {
                margin-bottom: 25px;
            }
            @include mobile {
                margin-bottom: 12px;
            }
        }

        &__order {
            float: right;
            width: 320px !important;
            box-sizing: border-box;
            transform: translate3d(0, 0, 0);

            &-wrapper {
                width: 320px;
                @include tablet {
                    width: auto;
                }
            }

            &-list-scroll {
                margin-right: -20px;
                padding-right: 20px;
                overflow: hidden;
                max-height: 465px;

                @include tablet {
                    margin-right: 0;
                    padding-right: 12px;
                    max-height: 45vh;
                }
            }

            &-list-scroll._isOdd {
                @include tablet {
                    max-height: 44vh;
                }
            }

            @include tablet {
                position: fixed;
                bottom: var(--footer-offset);
                background-color: $white-true;
                width: 100% !important;
                left: 0;
                bottom: 0;
                z-index: 99;
                &.abs {
                    position: absolute;
                }
                &-top {
                    max-height: 0;
                    overflow: hidden;
                    transition: all ease .3s;
                    margin-right: -12px;

                    .opened & {
                        display: block;
                        max-height: 999px;
                        margin-bottom: 17px;
                    }
                }
                &-bottom {
                    display: flex;

                    @include mobile {
                        display: block;
                    }
                }
                &-open {
                    display: block;
                    position: absolute;
                    background: center url(/local/templates/pnd/src/assets/i2/dropdown.svg) no-repeat;
                    height: 11px;
                    width: 16px;
                    transform: rotate(180deg);
                    top: 12px;
                    left: 50%;
                    margin-left: -8px;
                    @include mobile {
                        top: 9px;
                    }

                    .opened & {
                        transform: rotate(0);
                    }
                }
                &.opened {
                    z-index: 100;
                }
            }
            @include mobile {
                &-list {
                    padding-top: 14px;
                    border-top: 1px solid rgba(125, 121, 135, 0.15);
                }
            }

            &-list-warning {
                padding: 0.5em;
                margin: 1em 0;
                border: 1px solid #ffeeba;
                border-radius: 0.25em;
                color: #856404;
                background-color: #fff3cd;
                font-size: 0.9em;

                &:not(:last-child) {
                    margin-bottom: 5px;
                }

                @include mobile {
                    font-size: 0.7em;
                    margin: 0.5em 0;
                }
            }

            &-list-disclaimers {
                margin: 15px 0;

                @include tablet {
                    min-width: 100%;
                }

                @include mobile {
                    margin: 10px 0;
                }
            }

            &-border {
                border: 1px solid rgba(125, 121, 135, 0.2);
                padding: 26px 20px 20px;
                border-radius: 5px;
                @include tablet {
                    box-shadow: 10px -19px 50px rgba(0, 0, 0, 0.12);
                    padding: 26px 60px 20px;
                    border-radius: 0;
                    border: none;
                }
                @include mobile {
                    padding: 12px 12px 20px;
                }
            }

            &-shadow {
                position: fixed;
                z-index: 99;
                background: rgba(125, 121, 135, 0.34);
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }

            &-title {
                font-weight: 500;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 24px;
                @include mobile {
                    font-size: 16px;
                    line-height: 20px;
                    margin-bottom: 16px;
                    margin-top: 22px;
                    padding: 0 15px;
                }
            }

            &-item {
                border-bottom: 1px solid rgba(125, 121, 135, 0.15);
                padding-bottom: 23px;
                @include mobile {
                    padding-bottom: 20px;
                }

                &:not(:last-child) {
                    margin-bottom: 27px;
                }

                &-top {
                    display: flex;
                    justify-content: space-between;
                }

                &-price {
                    white-space: nowrap;
                    font-size: 14px;
                    @include mobile {
                        font-size: 16px;
                        line-height: 20px;
                        font-weight: 500;
                    }
                }

                &-name {
                    font-size: 14px;
                    line-height: 18px;
                    padding-right: 20px;
                    @include mobile {
                        font-size: 16px;
                        line-height: 22px;
                    }
                }

                &-close {
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: center url(/local/templates/pnd/src/assets/i2/close.svg) no-repeat;
                    margin-left: 8px;
                    cursor: pointer;
                    @include mobile {
                        margin-left: 4px;
                    }
                }

                &-desc {
                    color: $gray;
                }
            }

            &-total {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-weight: bold;
                padding: 6px 0 12px;
                margin-top: 10px;
                white-space: nowrap;

                @include tablet {
                    flex: 1;
                    margin-top: 0;
                    padding-top: 12px;
                }
                @include mobile {
                    padding: 0 12px 8px;
                }

                &-label {
                    margin-right: 1em;
                    font-size: 14px;

                    @include mobile {
                        font-size: 14px;
                        line-height: 18px;
                    }
                }

                &-value {
                    font-size: 18px;
                    line-height: 32px;
                    @include mobile {
                        font-size: 14px;
                        line-height: 18px;
                    }
                }
            }

            &-sum {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-top: 10px;
                white-space: nowrap;

                &-label {
                    margin-right: 1em;
                    font-size: 14px;

                    @include mobile {
                        font-size: 14px;
                        line-height: 18px;
                    }
                }

                &-value {
                    font-size: 18px;
                    line-height: 32px;
                    @include mobile {
                        font-size: 14px;
                        line-height: 18px;
                    }
                }
            }

            &-action {
                padding: 0.5em;
                margin: 1em 0;
                border: 1px solid #ffeeba;
                border-radius: 0.25em;
                color: #856404;
                background-color: #fff3cd;
                font-size: 0.9em;

                &__list {
                    font-weight: bold;
                }
            }

            &-btn {
                width: 100%;
                padding: 0px 30px;
                @include tablet {
                    width: 165px;
                    height: 40px;
                    margin-left: 30px;
                    padding: 0px 16px;
                }
                @include mobile {
                    width: 100%;
                    margin-left: 0;
                    height: 35px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                }
            }

            &-btn.column {
                @include tablet {
                    margin-left: 0;
                }

            }

            .count {
                margin-top: 13px;
            }
        }
        &__order.abs {
            .order-services__order-border {
                @include mobile {
                    padding: 12px 12px 35px;
                }
            }
        }

        &__buttons {
            margin-top: 58px;

            .button {
                margin-right: 10px;
            }
        }

        &__conditions {
            margin-top: 20px;
            @include mobile {
                margin-bottom: 50px;
            }

            .checkbox-icon {
                width: 24px;
                height: 24.8px;
                top: 3px;
                background-size: 16px;
                @include mobile {
                    top: 0;
                }
            }

            label {
                font-size: 12px;
                color: $gray;

                a {
                    text-decoration: underline;
                }
            }

            @include mobile {
                label {
                    display: flex;
                    align-items: center;
                    min-height: 24px;
                    font-size: 12px;
                    line-height: 14px;
                }
            }
        }

        .form__field {
            .error {
                position: absolute;
                margin-top: 2px;
                @include mobile {
                    position: static;
                    margin-top: 1px;
                }
            }
        }

    }

    .checkboxError {
        margin-top: 10px;
        font-size: 12px;
        color: rgb(255, 0, 0);
    }

    .form__row__name {
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 0px;
    }

    .form__row-col-data {
        margin: 0 -10px;
    }

    .form__field._selector-contracts {
        width: 20%;
        flex: auto;

        @include mobile {
            width: calc(100% - 20px);
        }
        
    }

    .order-services__order-bottom.column {
        @include tablet {
            flex-direction: column !important;
        }
    }

    .agreement_and_docs {
        margin-top: 10px;
    }

</style>
